import { FormControl, FormLabel } from '@chakra-ui/react';
import { UsStateSelect } from '@document/common/UsStateSelect';
import { FC } from 'react';
import { useOrganizationCompliancePage } from '~/apps/consumer/pages/Organizations/Compliance/OrganizationCompliancePageContext';

export const StateFilter: FC = () => {
  const { stateFilter, setStateFilter } = useOrganizationCompliancePage();

  return (
    <FormControl>
      <FormLabel>State</FormLabel>
      <UsStateSelect
        isMulti={false}
        size="sm"
        styles={{
          container: (provided) => ({
            ...provided,
            minWidth: 100,
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        value={stateFilter ? { label: stateFilter, value: stateFilter } : null}
        onChange={(option) => setStateFilter(option?.value || null)}
      />
    </FormControl>
  );
};
